export default __webpack_public_path__ + "static/media/mail.e433822b.svg";